import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import {NotFoundComponent} from './modules/general/not-found/not-found.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {RouterModule} from '@angular/router';
import {AppRoutingModule} from './app-routing.module';
import {NgMetro4Module} from 'ng-metro4';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {SharedModule} from './shared/shared.module';
import { LoginComponent } from './modules/general/login/login.component';
import {authInterceptorProviders} from './mocks/auth.interceptor';
import {NgxPaginationModule} from 'ngx-pagination';
import {ChoiceSiteComponent} from './modules/general/choice-site/choice-site.component';

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    ChoiceSiteComponent,
    LoginComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgMetro4Module,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      // isolate: true
    }),
    RouterModule,
    SharedModule,
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
    NgxPaginationModule,
  ],
  providers: [
    authInterceptorProviders
  ],
  bootstrap: [AppComponent],
  exports: [
  ]
})
export class AppModule { }

// tslint:disable-next-line:typedef
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
